import links from "@/links/links";
import qs from "qs";
import Resolution from "../models/Resolution";

export default {
  actions: {
    // NOTE: get with related resolutions
    FETCH(agencyId) {
      return this.get(links.RESOLUTION_CATALOG_FETCH(), {
        dataKey: "hydra:member",
      });
    },
    // NOTE: get with related resolutions & tags
    //       + custom filter: "*resolutions-catalogs-labels*", custom sort by: "*resolutions-catalogs-no-resolutions*"
    QUERY_FETCH(agencyId, queryParams) {
      // NOTE: prepare query params
      var processedQueryParams = {};
      // filters
      queryParams.filter.forEach(filter => {
        if (filter.column == "*resolutions-catalogs-labels*") {
          processedQueryParams["tags.id"] = filter.value;
        } else {
          processedQueryParams[filter.column] = filter.value;
        }
      });
      // order
      // TODO: order by the nb of resolutions
      processedQueryParams[`order[${queryParams.sort.by}]`] = queryParams.sort.dir.toLowerCase();
      // page
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;
      return this.get(links.RESOLUTION_CATALOG_QUERY_FETCH(), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    // NOTE: get with related resolutions & tags
    GET(id) {
      return this.get(links.RESOLUTION_CATALOG_GET(id), {
        dataTransformer: res => {
          Resolution.insertOrUpdate({
            data: res.data.resolutions,
          });
          return res.data;
        },
      });
    },
    CHECK_POSITION(item) {
      return this.post(links.RESOLUTION_CATALOG_CHECK_POSITION(), item);
    },
    POST(item) {
      return this.post(links.RESOLUTION_CATALOG_POST(), item);
    },
    PUT(item) {
      return this.put(links.RESOLUTION_CATALOG_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.RESOLUTION_CATALOG_DELETE(item.id), {
        delete: item.id,
      });
    },
    // NOTE: create copy of resolution catalog then use its id to create resolutions and attach tags (code in middlewares)
    //       .. item = { .. resolutions: [], tags: []  }
    DUPLICATE(item) {
      return this.post(links.RESOLUTION_CATALOG_DUPLICATE(), item);
    },
  },
};
